import Vue from 'vue'

const alert = (title, message, callback, dangerouslyUseHTMLString = false) => {
  window.getApp.$emit(
      'ALERT',
      title,
      message,
      callback,
      dangerouslyUseHTMLString

  )
}

const confirm = (title, message, confirm, cancel, dangerouslyUseHTMLString = false) => {
  window.getApp.$emit(
      'CONFIRM',
      title,
      message,
      confirm,
      cancel,
      dangerouslyUseHTMLString
  )
}

const prompt = (title, message, callback, dangerouslyUseHTMLString = false) => {
  window.getApp.$emit(
      'PROMPT',
      title,
      message,
      callback,
      dangerouslyUseHTMLString

  )
}

const info = (message) => {
  window.getApp.$emit(
    'INFO',
    message
  )
}

const fail = (message) => {
  window.getApp.$emit(
    'FAIL',
    message
  )
}

Vue.prototype.$alert = alert
Vue.prototype.$confirm = confirm
Vue.prototype.$prompt = prompt
Vue.prototype.$fail = fail
Vue.prototype.$info = info
